export default __webpack_public_path__ + "static/media/guideme_lancingkit_lancets100_strips150_scale_white@3x.1893e03e.webp";